import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import isEqual from 'lodash/isEqual';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import omit from 'lodash/omit';
import loadScript from '../../lib/loadScript';

let c3;

class C3Chart extends React.Component {
  constructor(props) {
    super(props);

    this.chart = null;

    this.generateChart = this.generateChart.bind(this);
    this.destroyChart = this.destroyChart.bind(this);
  }

  /* istanbul ignore next: see https://github.com/NerdWallet/review-client/pull/348 */
  componentDidMount(prevProps) {
    const initChart = ([c3lib]) => {
      c3 = c3lib;
      this.generateChart(this.props, prevProps);
    };
    if (c3) {
      this.generateChart(this.props, prevProps);
    } else {
      const chartLibraries = [
        loadScript('https://unpkg.com/c3@0.4.18/c3.min.js', 'c3'),
        loadScript('https://unpkg.com/d3@3.5.17/d3.min.js', 'd3'),
      ];
      const onError = () => {
        this.chartError = true;
      };
      Promise.all(chartLibraries).then(initChart, onError).catch(onError);
    }
  }

  shouldComponentUpdate(nextProps) {
    return this.props.data !== nextProps.data;
  }

  componentDidUpdate(prevProps) {
    this.generateChart(this.props, prevProps);
  }

  componentWillUnmount() {
    this.destroyChart();
  }

  generateChart(props, prevProps = props) {
    if (this.chart && isEqual(omit(props, 'data'), omit(prevProps, 'data'))) {
      // If only the data change, only refresh the data on the current chart
      this.chart.load({
        ...props.data,
      });
    } else if (c3) {
      const chartData = {
        bindto: `#${this.props.uniqueId}`,
        data: props.data,
        ...props.options,
      };
      this.chart = c3.generate(chartData);
    }
  }

  destroyChart() {
    return this.chart && this.chart.destroy();
  }

  render() {
    return this.chartError ? null : (
      <div id={this.props.uniqueId} className="c3-chart" />
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
C3Chart.displayName = 'C3 Chart';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
C3Chart.propTypes = {
  uniqueId: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  options: PropTypes.object,
};

export default C3Chart;
